import { useEffect, useRef, useState } from 'react'

export const ANALYSIS_CHART_COLORS = ['var(--chart-6)', 'var(--chart-2)', 'var(--chart-3)', 'var(--chart-1)', 'var(--chart-4)', 'var(--chart-5)']

export const AXIS_TICK_PROPS = {
  fill: 'var(--chart-axis)',
  fontSize: 11,
  fontWeight: 700,
} as const

export const useChartDimensions = <TElement extends HTMLElement>() => {
  const ref = useRef<TElement | null>(null)
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const node = ref.current
    if (!node) return undefined
    const update = () => {
      const rect = node.getBoundingClientRect()
      setDimensions({
        width: Math.max(1, Math.round(rect.width)),
        height: Math.max(1, Math.round(rect.height)),
      })
    }
    update()
    const observer = new ResizeObserver(update)
    observer.observe(node)
    return () => observer.disconnect()
  }, [])

  return { ref, dimensions }
}

export const formatTooltipValue = (value: number, kind: 'number' | 'percent' = 'number') =>
  kind === 'percent' ? `${Math.round(value)}%` : new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(value)

export const chartColor = (index: number) => ANALYSIS_CHART_COLORS[index % ANALYSIS_CHART_COLORS.length]
